import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";

const APPLICATION_IMAGE_KEYS = [
  "applicationImages",
  "images",
  "applicationImage",
];

export const useViewApplicationImages = ({ page, limit, q, status } = {}) => {
  const isPaginated = page !== undefined && limit !== undefined;
  const trimmedQ = q?.trim?.() ?? "";
  const statusFilter = status?.trim?.() || "all";

  return useQuery({
    queryKey: isPaginated
      ? ["viewApplicationImages", page, limit, trimmedQ, statusFilter]
      : ["viewApplicationImages"],
    queryFn: async () => {
      const params = {};
      if (isPaginated) {
        params.page = page;
        params.limit = limit;
        if (trimmedQ) params.q = trimmedQ;
        if (statusFilter && statusFilter !== "all") {
          params.status = statusFilter;
        }
      }

      const res = await api.get("/application-image/all", { params });

      if (isPaginated) {
        const parsed = parsePaginatedResponse(
          res.data,
          APPLICATION_IMAGE_KEYS,
          limit,
        );
        return {
          applicationImages: parsed.items,
          pagination: parsed.pagination,
        };
      }

      return res.data;
    },
    placeholderData: isPaginated
      ? (previousData) => previousData
      : undefined,
    staleTime: isPaginated ? 60_000 : undefined,
  });
};
